export const SCORE_AGGR_METHODS = {
  score_cpu: 'first',
  score_gpu_1080: 'first',
  score_gpu_1440: 'first',
  score_gpu_4k: 'first',
  score_professional: 'sum',
  score_ram: 'first',
  score_rgb: 'sum',
  score_silent: 'sum',
  score_ssd: 'first',
  score_stealth: 'sum',
};

/**
 * Available methods: first, sum
 */
export const calculateScore = (options, attrName) => {
  if (options && options.length) {
    const attrs = options
      .filter((option) => option.id)
      .reduce((acc, option) => acc.concat(option.tags[0]), []);

    const filteredAttrs = attrs.filter(({ name }) => name === attrName);
    const method = SCORE_AGGR_METHODS[attrName];

    if (method === 'sum') {
      const sum = filteredAttrs.reduce(
        (acc, { value }) => acc + Number(value),
        0,
      );

      return Math.min(sum, 20);
    }

    return Number(filteredAttrs[0]?.value) || 0;
  }
  return 0;
};
export const calculateScoreRTS = (options, attrName) => {
  if (options && options.length) {
    const filteredAttrs = options.filter(({ name }) => name === attrName);
    const method = SCORE_AGGR_METHODS[attrName];

    if (method === 'sum') {
      const sum = filteredAttrs.reduce(
        (acc, { value }) => acc + Number(value),
        0,
      );

      return Math.min(sum, 20);
    }

    return Number(filteredAttrs[0]?.value) || 0;
  }
  return 0;
};
